import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './index.less';
import { getContrastTextColor } from '@/_util';
import { getProServcatgTree } from '@/_serveice/project';
import { flattenTree } from '../../..';
import { Input, Tooltip } from 'kenshin';

// 缓存数据，避免
const optioneMap = new Map();

let timer = null;
const Select = ({
  options = [],
  value = '',
  onChange,
  placeholder = '',
  row,
  col,
  prop,
  multiple = false,
  emptyText = '暂无选项',
  hotInstance,
  disabled = false,
  hasInput = false,
  filterInp = false,
  columns = [],
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [position, setPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
    top: undefined,
  });
  const selectRef = useRef(null);
  const selectedOption = options.find((opt) => opt.value === value);
  const onceSelf = useRef(false);
  const [filterValue, setFilterValue] = useState('');

  const [selectOptions, setSelectOptions] = useState([]);
  // 获取所有列数据

  const allColumns =
    columns.length > 0 ? columns : hotInstance?.getSettings().columns || [];
  const baseIndex = allColumns.findIndex((col) => col.data === '_baseData');

  const isInput = hotInstance?.getDataAtCell(row, baseIndex);

  useEffect(() => {
    setSelectOptions(options);
  }, [options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const setSource = (source) => {
    if (hotInstance) {
      const customerCell = hotInstance.getCellMeta(row, col);
      if (customerCell) {
        customerCell.source = source;
        hotInstance.render();
      }
    }
  };

  const projectGetOptions = () => {
    if (prop != 'proServCatgId') return;
    if (onceSelf.current) return;
    if (selectOptions.length > 0) return;
    let id;
    // 查找projectId所在的列索引
    const projectIdColIndex = allColumns.findIndex(
      (col) => col.data === 'projectId',
    );
    if (projectIdColIndex !== -1) {
      // 获取当前行的projectId值
      const projectIdValue = hotInstance?.getDataAtCell(row, projectIdColIndex);

      if (projectIdValue) {
        id = projectIdValue;
      }
    }
    onceSelf.current = true;
    if (!id) return;

    if (optioneMap.has(id)) {
      setSelectOptions(optioneMap.get(id));
      // 设置当前row,col对应单元格的source
      setSource(optioneMap.get(id));
      return;
    }

    getProServcatgTree({ projectId: id }).then((res) => {
      let source = flattenTree(res.data).map((item) => ({
        label: item.servCatgName,
        value: item.proServCatgId,
      }));
      optioneMap.set(id, source);
      setSelectOptions(source);
      setSource(source);
      if (hotInstance) {
        const customerCell = hotInstance.getCellMeta(row, col);
        if (customerCell) {
          customerCell.source = source;
          hotInstance.render();
        }
      }
    });
  };

  const getBaseBol = () => {
    const baseIndex = allColumns.findIndex((col) => col.data === '_baseData');
    return hotInstance?.getDataAtCell(row, baseIndex);
  };

  const handleClick = () => {
    if (disabled) return;
    if (hasInput && getBaseBol()) {
      return;
    }
    // 当打开下拉框时，关闭tooltip
    setTooltipVisible(false);

    if (!isOpen) {
      projectGetOptions();
      const rect = selectRef.current.getBoundingClientRect();
      let style = {
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      };
      if (rect.bottom + 400 > window.innerHeight) {
        style.top = undefined;
        style.bottom = window.innerHeight - rect.top;
      }
      setPosition(style);
    }
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    clearTimeout(timer);
    setFilterValue('');
    if (multiple) {
      const currValueArr = value.split(',');
      if (currValueArr.includes(option.value)) {
        currValueArr.splice(currValueArr.indexOf(option.value), 1);
      } else {
        currValueArr.push(option.value);
      }
      onChange?.(currValueArr.filter(Boolean).join(','));
      setIsOpen(false);
      return;
    }
    onChange?.(option.value);
    setIsOpen(false);
  };

  const handleInput = (e) => {
    const value = e.target.value;
    setFilterValue(value);
  };

  const renderItem = (value, index) => {
    if (hasInput) {
      return (
        <Input.TextArea
          defaultValue={value}
          disabled={disabled}
          onChange={handleInput}
          autoSize
          onPressEnter={(e) => {
            if (e.shiftKey) return;
            e.preventDefault();
            e.target.blur();
          }}
          onBlur={(e) => {
            if (filterInp) return;
            timer = setTimeout(() => {
              console.log('失去焦点', e.target.value);
              setFilterValue('');
              onChange(e.target.value);
            }, 500);
          }}
        />
      );
    }
    const item = selectOptions.find((opt) => opt.value === value);
    if (!item) return value;
    return (
      <span
        className="select-value select-option-label"
        key={index}
        style={{
          backgroundColor: item?.color,
          color: getContrastTextColor(item?.color || '#ffffff'),
        }}
        title={item?.label}
      >
        {item ? item.label : placeholder}
      </span>
    );
  };

  // if (isInput && hasInput) {
  //   return (
  //     <div className="custom-select" ref={selectRef}>
  //       <input
  //         defaultValue={value}
  //         onBlur={(e) => onChange(e.target.value)}
  //         disabled={disabled}
  //       />
  //     </div>
  //   );
  // }

  const handleTooltipVisibleChange = (visible) => {
    // 只有在下拉框关闭的情况下才允许显示tooltip
    if (!isOpen) {
      setTooltipVisible(visible);
    }
  };

  const renderValue = () => {
    // if (isInput && hasInput) {
    //   return (
    //     <div className="select-trigger" onClick={handleClick}>
    //       <input
    //         defaultValue={value}
    //         onBlur={(e) => onChange(e.target.value)}
    //         disabled={disabled}
    //       />
    //     </div>
    //   );
    // }
    return (
      <>
        {multiple && (
          <Tooltip
            overlayStyle={{
              width: 200,
              maxWidth: 200,
            }}
            color="#fff"
            visible={tooltipVisible}
            onVisibleChange={handleTooltipVisibleChange}
            title={
              <div className="select-trigger">
                {value
                  .split(',')
                  .filter(Boolean)
                  .map((item, index) => renderItem(item, index))}
              </div>
            }
          >
            <div className="select-trigger" onClick={handleClick}>
              {multiple
                ? value
                    .split(',')
                    .filter(Boolean)
                    .slice(0, 4)
                    .map((item, index) => renderItem(item, index))
                : renderItem(value, 0)}
              {multiple && value.split(',').length > 4 && <div>...</div>}
            </div>
          </Tooltip>
        )}
        {!multiple && (
          <div className="select-trigger" onClick={handleClick}>
            {multiple
              ? value
                  .split(',')
                  .filter(Boolean)
                  .map((item, index) => renderItem(item, index))
              : renderItem(value, 0)}
          </div>
        )}
      </>
    );
  };

  return (
    <div className="custom-select" ref={selectRef}>
      {renderValue()}
      {isOpen &&
        createPortal(
          <div
            className="select-options"
            style={{
              top: `${position.top}px`,
              left: `${position.left}px`,
              width: `${position.width}px`,
              bottom: `${position.bottom}px`,
            }}
          >
            {selectOptions.length != 0 && filterInp && (
              <Input
                onClick={(e) => e.stopPropagation()}
                onInput={handleInput}
              />
            )}
            <div className="select-options-list">
              {selectOptions
                .filter((item) => {
                  if (typeof item.label === 'object') {
                    return item.label?.props['data-label']
                      .toString()
                      .includes(filterValue);
                  }
                  return item.label?.toString().includes(filterValue);
                })
                .map((option) => (
                  <div
                    key={option.value}
                    className={`select-option ${
                      value.split(',').includes(option.value) ? 'selected' : ''
                    }`}
                    onClick={() => handleOptionClick(option)}
                  >
                    <div
                      className="select-option-label"
                      style={{
                        backgroundColor: option.color,
                        color: getContrastTextColor(option.color || '#ffffff'),
                      }}
                    >
                      {option.label}
                    </div>
                  </div>
                ))}
            </div>
            {selectOptions.length === 0 && (
              <div className="empty-text">{emptyText}</div>
            )}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default Select;
